<template>
    <div class="order-quantity-container">
      <div class="count-container">
        <div class="txt-color title title-flex">办卡统计饼图</div>
      </div>
      <div ref="plot" class="plot"></div>
    </div>
  </template>
  <script>
  import { Pie } from "@antv/g2plot";
  import { format, subDays } from "date-fns";
  export default {
    name: "order-quantity",
    components: {  },
    props: {
      data: {
        type: Array,
        default: () => {
          return [];
        }
      },
      time: {
        type: Array,
        default: () => {
          return [
            format(subDays(new Date(), 7), "yyyy-MM-dd"),
            format(new Date(), "yyyy-MM-dd")
          ];
        }
      }
    },
    data() {
      return {
        plot: null,
      };
    },
    computed: {},
    mounted() {},
    methods: {
      initPieData(list, _data) {
        const plotEl = this.$refs["plot"];
        if (!plotEl) return;
        const data = list;
        const plotConfig = {
          appendPadding: 10,
            angleField: 'value',
            colorField: 'name',
            radius: 0.75,
            label: {
              type: 'spider',
              labelHeight: 28,
              content: '{name}\n{percentage}',
            },
          tooltip: {
            formatter: datum => {
              return {
                name:datum.name+'办卡',
                value: datum.value+"张"
              };
            }
          },
          legend: {
            position: "top-right"
          }
        };
  
        if (this.plot !== null) {
          this.plot.changeData(data);
        } else {
          this.plot = new Pie(plotEl, { ...plotConfig, data });
          this.plot.render();
        }
      }
    }
  };
  </script>
  <style scoped lang="scss">
  .order-quantity-container {
    display: flex;
    flex-direction: column;
    box-sizing: border-box;
  }
  
  </style>
  